import type {
  SearchResultsOption as SearchResultsOptionSchema,
  BookingPanelOption as BookingPanelOptionSchema,
  SearchResultsPage as SearchResultsPageSchema,
  Search as SearchSchema,
} from '@skyscanner-internal/schemas-types/clients.pb';

export const CLIENTS_SEARCH = 'clients.Search';
export const CLIENTS_SEARCH_RESULT_PAGE = 'clients.SearchResultsPage';
export const CLIENTS_SEARCH_RESULT_OPTION = 'clients.SearchResultsOption';
export const CLIENTS_BOOKING_PANEL_OPTION = 'clients.BookingPanelOption';
export type BookingPanelOption = BookingPanelOptionSchema;
export type SearchResultsOption = SearchResultsOptionSchema;
export type SearchResultsPage = SearchResultsPageSchema;
export type Search = SearchSchema;
export type FunnelEventProperty = BookingPanelOption | SearchResultsOption | SearchResultsPage | {};

export type SchemaName = string;
export type FunnelEventClientSearch = typeof CLIENTS_SEARCH;
export type FunnelEventClientSearchResultsPage = typeof CLIENTS_SEARCH_RESULT_PAGE;
export type FunnelEventClientSearchResultsOption = typeof CLIENTS_SEARCH_RESULT_OPTION;
export type FunnelEventClientSearchBookingPanelOption = typeof CLIENTS_BOOKING_PANEL_OPTION;
export type FunnelEventEventName =
  | FunnelEventClientSearch
  | FunnelEventClientSearchResultsPage
  | FunnelEventClientSearchResultsOption
  | FunnelEventClientSearchBookingPanelOption;
export type FunnelEventProperties = Record<string, FunnelEventProperty>;
export type SearchID = string;
